const updates = [
  { date: '07-31', title: '《庆余年3》全集已上线', desc: '范闲归来，权谋江湖全新篇章正式开启，全集一次放出。', tag: '新剧上线', accent: true },
  { date: '07-30', title: '平台新增4K专区', desc: '精选热门剧集全面升级4K超清画质，带来更极致的视觉体验。', tag: '功能更新', accent: false },
  { date: '07-29', title: '《眼泪女王》大结局上线', desc: '年度甜虐韩剧迎来催泪大结局，金秀贤金智媛完美收官。', tag: '热门', accent: true },
  { date: '07-28', title: '韩剧频道全面改版', desc: '优化韩剧分类与推荐算法，追韩剧更方便，新剧同步速度再提升。', tag: '功能更新', accent: false },
  { date: '07-27', title: '《玫瑰的故事》热度破纪录', desc: '刘亦菲主演剧集单日观看量突破平台历史纪录，口碑持续发酵。', tag: '数据', accent: false },
  { date: '07-26', title: '新增日剧频道上线', desc: '精选百部高分日剧正式入驻，涵盖治愈、悬疑、爱情等多元题材。', tag: '新剧上线', accent: true },
  { date: '07-25', title: '移动端体验全面优化', desc: '适配最新系统版本，优化触控交互，移动观影更加流畅顺滑。', tag: '功能更新', accent: false },
  { date: '07-24', title: '《三体》4K重制版发布', desc: '采用全新渲染技术，画质和特效全面升级，科幻迷不容错过。', tag: '热门', accent: true },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          最新动态
        </h2>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>
          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 pl-10">
                <div className={`absolute left-0 w-[38px] h-[38px] rounded-full flex items-center justify-center border-2 ${
                  item.accent
                    ? 'bg-accent-100 border-accent-300 text-accent-700'
                    : 'bg-background-100 border-background-300 text-foreground-500'
                }`}>
                  <span className="text-[10px] font-bold leading-tight text-center">{item.date}</span>
                </div>
                <div className="flex-1 bg-background-100 rounded-lg border border-background-200/70 p-4">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.accent ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}